<template>
  <alert :type="type" :color="color">
    <div>1、公众号分为订阅号、服务号，根据微信公众平台的接口规则，不同类型的公众号可使用不同的功能；如果是认证的服务号则下面的全部功能均可使用！</div>
    <div>2、认证：在公众平台后台提交企业资料并向微信支付300元的认证费用并审核通过，叫公众号认证；如果公众号没有认证则只能使用下面的部分功能！</div>
    <div>3、该公众号（{{nickName}}）是已认证的服务号，下面的全部功能均可使用！</div>
  </alert>
</template>

<script>
import store from 'store';
export default {
  name: 'AlertTips',
  props: {
    type: {
      type: String,
      default: 'success',
    },
    color: {
      type: String,
    },
  },
  data() {
    return {
      nickName: '---',
    };
  },
  created() {
    this.nickName = '';
    setTimeout(() => {
      this.nickName = store.get('oaNickName');
    }, 300);
  },
};
</script>
